import { render, staticRenderFns } from "./StockPanel.vue?vue&type=template&id=252f6ae6&lang=pug&"
import script from "./StockPanel.vue?vue&type=script&lang=js&"
export * from "./StockPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports